import styled from 'styled-components';
import { pulseAnimation } from './common';

export type JRCSkeletonSquareProps = {
    ratio?: { x: number; y: number };
    width?: string;
    borderRadius?: string;
    margin?: string;
};
export const JRCSkeletonSquare = styled.div<JRCSkeletonSquareProps>`
    width: ${(props) => (props.ratio ? '100%' : props.width || `60%`)};
    height: ${(props) => (props.ratio ? '0' : props.width || `0.7em`)};
    padding-bottom: ${(props) => (props.ratio ? (100 * props.ratio.y) / props.ratio.x + '%' : '0')};
    border-radius: ${(props) => props.borderRadius || '4px'};
    margin: ${(props) => props.margin};
    ${pulseAnimation}
`;
